<template>
  <div>
    <div class="top">
      <router-link class="link-back" :to="'/resources'">
        <div>
          &larr; Back to Resources
        </div>
      </router-link>
      <bg-button @click="saveResource" text="Save"></bg-button>
    </div>

    <div class="article">
      <div
        class="image"
        v-if="article.image"
        :style="
          `background-image: url(${
            article.image
          }); background-position: center;`
        "
      >
        <div class="uploadbutton" @click="trigger">
          <input
            ref="headerRef"
            type="file"
            @change="onFileChange"
            accept="image/*"
          />
          <p>Upload image</p>
        </div>
      </div>
      <div class="image" v-if="!article.image">
        <div class="uploadbutton" @click="trigger">
          <input
            ref="headerRef"
            type="file"
            @change="onFileChange"
            accept="image/*"
          />
          <p>Upload image</p>
        </div>
      </div>
      <div class="content">
        <div class="input-tags">
          <bg-select
            placeholder="Add tags"
            :searchable="true"
            :multiple="true"
            :options="tagsOptions"
            :createNew="true"
            v-model="article.tags"
          ></bg-select>
        </div>
        <div class="content-header">
          <div class="title">
            <h1
              v-bg-typography="'h1'"
              @mouseover="mouseOver = true"
              @mouseleave="mouseOver = false"
              @click="showInput"
              v-if="!typing"
            >
              {{ article.title }}
            </h1>
            <input
              type="text"
              ref="inputName"
              id="inputName"
              v-model="article.title"
              v-if="typing"
              @blur="typing = false"
            />
          </div>
          <div class="type">
            <bg-select
              placeholder="Choose type"
              :searchable="false"
              :multiple="false"
              :options="typeOptions"
              v-model="article.resource_type"
            ></bg-select>
          </div>
        </div>

        <div class="content-body">
          <Editor
            :extended="true"
            :loadContent="article.body"
            :dark="true"
            @update="updateArticle"
            v-if="loadCompleted"
          >
          </Editor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";
import BgButton from "@/components/bg-button";
import Editor from "@/components/editor";
import BgIcon from "@/components/bg-icon";
import BgSelect from "@/components/bg-select";
import API from "@/api";

export default {
  components: {
    BgButton,
    Editor,
    BgIcon,
    BgSelect,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      article: {
        title: "New title",
        tags: [],
        date: "",
        author: "",
        author_id: null,
        favorited: [],
        id: null,
        body: "<div><p><b>Start</b> typing here..</p></div>",
        views: 0,
        image: "",
        resource_type: null,
      },
      tagsOptions: [],
      typeOptions: [
        { label: "help", code: 0 },
        { label: "blog", code: 1 },
        { label: "product update", code: 2 },
        { label: "news", code: 3 },
        { label: "case", code: 4 },
      ],
      typing: false,
      mouseOver: false,
      imageUpdated: false,
      loadCompleted: false,
    };
  },
  methods: {
    focusInput() {
      this.$refs.inputName.focus();
    },
    async onFileChange() {
      const url = await this.toBase64(this.$refs.headerRef.files[0]);
      this.article.image = url;
      this.imageUpdated = true;
    },
    showInput() {
      // Show the input component
      this.typing = true;
      this.mouseOver = false;

      // Focus the component, but we have to wait
      // so that it will be showing first.
      this.$nextTick(() => {
        this.focusInput();
      });
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    trigger() {
      this.$refs.headerRef.click();
    },
    updateArticle(val) {
      this.article.body = val;
    },
    async saveResource() {
      const payload = { ...this.article };
      payload.resource_type = payload.resource_type.code;
      if (!this.imageUpdated) {
        delete payload.image;
      }
      if (payload.id === null) {
        payload.author_id = this.$store.state.user.user.id;
        const result = await API.resource.createResource(payload);
        this.$router.push(`/resources/${result.id}`);
      } else {
        await API.resource.updateResource(payload);
        this.$router.push(`/resources/${payload.id}`);
      }
    },
  },
  async mounted() {
    if (this.$route.params.id !== null && this.$route.params.id !== undefined) {
      const result = await API.resource.getResource(this.$route.params.id);
      this.article = {
        title: result.title,
        tags: result.tags,
        date: result.date,
        author: result.author,
        author_id: result.author_id,
        favorited: [],
        id: result.id,
        body: result.body,
        views: 0,
        image: result.image,
        resource_type: this.typeOptions.find(
          (elem) => elem.code === result.resource_type
        ),
      };
    }
    const result = await API.resource.getResourceTags();
    result.resource_tags.forEach((tag) => {
      this.tagsOptions.push(tag.tag);
    });
    this.loadCompleted = true;
  },
};
</script>

<style scoped lang="scss">
@import "./styles.scss";
</style>

<style>
li {
  list-style-type: circle;
  list-style-position: inside;
}

li p {
  display: inline;
}
</style>
